import { FormikContext } from 'formik'
import { BaseSyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormik } from '../../../../../common/hooks/formik'
import { PureInput } from '../../../../../common/ui/pure-input/pure-input'
import { useFBField } from '../../form-builder.context'
import { FormBuilderConfig } from '../../types/form-builder.types'

export const HeaderConfig = () => {
  const { t } = useTranslation()
  const { value: configValue, setValue } = useFBField()

  const formik = useFormik<any>({
    initialValues: { name: '' },
    validationSchema: {},
    onSubmit: (values) => {
      console.log('values', values)
    },
  })

  const handleChange = (key: string, value: BaseSyntheticEvent) => {
    setValue({ ...configValue, [key]: value.target.value } as unknown as FormBuilderConfig)
  }

  return (
    <FormikContext.Provider value={formik as any}>
      <form onSubmit={formik.handleSubmit}>
        <PureInput
          {...formik.getFieldProps('name')}
          name="name"
          onInput={(e) => handleChange('label', e)}
          placeholder={t('common.name')}
          size="small"
        />
      </form>
    </FormikContext.Provider>
  )
}
